export interface PlayerMask {
  playVideo: () => void;
  pauseVideo: () => void;
  getIframe: () => HTMLIFrameElement;
}

export interface YTStateChangeEvent {
  data: number;
}

export function includeYTScript(): void {
  const videoScriptTag = document.getElementById('yt-video-script');
  if (!videoScriptTag) {
    const tag = document.createElement('script');
    tag.id = 'yt-video-script';
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
  }
}

export function checkIfPayerReady(): void {
  Alpine.store('ytPlayerReady', false);
  (window as any).onYouTubeIframeAPIReady = () => Alpine.store('ytPlayerReady', true);
}



